var Utils = require("./utils");
var queryArray = Utils.queryArray;

var companySelector = document.querySelector("select#companyId");
var locationSelector = document.querySelector("select#locationId");
var categorySelector = document.querySelector("select#categoryIds");
var companyIndex = 0;
var locationIndex = 0;

companySelector.addEventListener("change", populateCompanyInfo);
locationSelector.addEventListener("change", populateLocationInfo);
categorySelector.addEventListener("change", populateCategoryInfo);

function populateCompanyInfo() {
  companyIndex = companySelector.selectedIndex;
  var companyMembershipId = document.querySelector("#companyMembershipId");
  var companyName = document.querySelector("#companyName");
  var companyAddressId = document.querySelector("#companyAddressId");
  var companyStreetAddress = document.querySelector("#companyStreetAddress");
  var companySuiteNumber = document.querySelector("#companySuiteNumber");
  var companyCity = document.querySelector("#companyCity");
  var companyState = document.querySelector("#companyState");
  var companyPostalCode = document.querySelector("#companyPostalCode");
  var companyCountry = document.querySelector("#companyCountry");
  var companyEmailId = document.querySelector("#companyEmailId");
  var companyEmail = document.querySelector("#companyEmail");
  var companyPhoneId = document.querySelector("#companyPhoneId");
  var companyPhone = document.querySelector("#companyPhone");
  var companyUrlId = document.querySelector("#companyUrlId");
  var companyUrl = document.querySelector("#companyUrl");
  var contactJobTitle = document.querySelector("#contactJobTitle");

  companyMembershipId.value =
    (companyMemberships[companyIndex] && companyMemberships[companyIndex].id) ||
    "";
  companyName.value =
    (companyMemberships[companyIndex] &&
      companyMemberships[companyIndex].companyName) ||
    "";
  companyAddressId.value =
    (companyMemberships[companyIndex] &&
      companyMemberships[companyIndex].address &&
      companyMemberships[companyIndex].address.id) ||
    "";
  companyStreetAddress.value =
    (companyMemberships[companyIndex] &&
      companyMemberships[companyIndex].address &&
      companyMemberships[companyIndex].address.streetAddress) ||
    "";
  companySuiteNumber.value =
    (companyMemberships[companyIndex] &&
      companyMemberships[companyIndex].address &&
      companyMemberships[companyIndex].address.suiteNumber) ||
    "";
  companyCity.value =
    (companyMemberships[companyIndex] &&
      companyMemberships[companyIndex].address &&
      companyMemberships[companyIndex].address.city) ||
    "";
  companyState.value =
    (companyMemberships[companyIndex] &&
      companyMemberships[companyIndex].address &&
      companyMemberships[companyIndex].address.state) ||
    "";
  companyPostalCode.value =
    (companyMemberships[companyIndex] &&
      companyMemberships[companyIndex].address &&
      companyMemberships[companyIndex].address.postalCode) ||
    "";
  companyCountry.value =
    (companyMemberships[companyIndex] &&
      companyMemberships[companyIndex].address &&
      companyMemberships[companyIndex].address.country) ||
    "";
  companyEmailId.value =
    (companyMemberships[companyIndex] &&
      companyMemberships[companyIndex].email &&
      companyMemberships[companyIndex].email.id) ||
    "";
  companyEmail.value =
    (companyMemberships[companyIndex] &&
      companyMemberships[companyIndex].email &&
      companyMemberships[companyIndex].email.emailAddress) ||
    "";
  companyPhoneId.value =
    (companyMemberships[companyIndex] &&
      companyMemberships[companyIndex].phone &&
      companyMemberships[companyIndex].phone.id) ||
    "";
  companyPhone.value =
    (companyMemberships[companyIndex] &&
      companyMemberships[companyIndex].phone &&
      companyMemberships[companyIndex].phone.phoneNumber) ||
    "";
  companyUrlId.value =
    (companyMemberships[companyIndex] &&
      companyMemberships[companyIndex].url &&
      companyMemberships[companyIndex].url.id) ||
    "";
  companyUrl.value =
    (companyMemberships[companyIndex] &&
      companyMemberships[companyIndex].url &&
      companyMemberships[companyIndex].url.url) ||
    "";
  contactJobTitle.value =
    (companyMemberships[companyIndex] &&
      companyMemberships[companyIndex].title) ||
    "";

  populateLocationOptions();
  populateLocationInfo();
}

function populateLocationOptions() {
  locationSelector.options.length = 0;
  var locations =
    (companyMemberships &&
      companyMemberships[companyIndex] &&
      companyMemberships[companyIndex].locations) ||
    [];
  for (var i = 0; i < locations.length; i++) {
    var option = document.createElement("option");
    option.value = locations[i].id;
    option.innerHTML = locations[i].name;
    locationSelector.append(option);
  }
  var newOption = document.createElement("option");
  newOption.value = "";
  newOption.innerHTML = "Create New Plant";
  locationSelector.append(newOption);
}

function populateLocationInfo() {
  locationIndex = locationSelector.selectedIndex;

  var plantName = document.querySelector("#plantName");
  var plantAddressId = document.querySelector("#plantAddressId");
  var plantStreetAddress = document.querySelector("#plantStreetAddress");
  var plantSuiteNumber = document.querySelector("#plantSuiteNumber");
  var plantCity = document.querySelector("#plantCity");
  var plantState = document.querySelector("#plantState");
  var plantPostalCode = document.querySelector("#plantPostalCode");
  var plantCountry = document.querySelector("#plantCountry");

  plantName.value =
    (companyMemberships[companyIndex] &&
      companyMemberships[companyIndex].locations &&
      companyMemberships[companyIndex].locations[locationIndex] &&
      companyMemberships[companyIndex].locations[locationIndex].name) ||
    "";
  plantAddressId.value =
    (companyMemberships[companyIndex] &&
      companyMemberships[companyIndex].locations &&
      companyMemberships[companyIndex].locations[locationIndex] &&
      companyMemberships[companyIndex].locations[locationIndex].address &&
      companyMemberships[companyIndex].locations[locationIndex].address.id) ||
    "";
  plantStreetAddress.value =
    (companyMemberships[companyIndex] &&
      companyMemberships[companyIndex].locations &&
      companyMemberships[companyIndex].locations[locationIndex] &&
      companyMemberships[companyIndex].locations[locationIndex].address &&
      companyMemberships[companyIndex].locations[locationIndex].address
        .streetAddress) ||
    "";
  plantSuiteNumber.value =
    (companyMemberships[companyIndex] &&
      companyMemberships[companyIndex].locations &&
      companyMemberships[companyIndex].locations[locationIndex] &&
      companyMemberships[companyIndex].locations[locationIndex].address &&
      companyMemberships[companyIndex].locations[locationIndex].address
        .suiteNumber) ||
    "";
  plantCity.value =
    (companyMemberships[companyIndex] &&
      companyMemberships[companyIndex].locations &&
      companyMemberships[companyIndex].locations[locationIndex] &&
      companyMemberships[companyIndex].locations[locationIndex].address &&
      companyMemberships[companyIndex].locations[locationIndex].address.city) ||
    "";
  plantState.value =
    (companyMemberships[companyIndex] &&
      companyMemberships[companyIndex].locations &&
      companyMemberships[companyIndex].locations[locationIndex] &&
      companyMemberships[companyIndex].locations[locationIndex].address &&
      companyMemberships[companyIndex].locations[locationIndex].address
        .state) ||
    "";
  plantPostalCode.value =
    (companyMemberships[companyIndex] &&
      companyMemberships[companyIndex].locations &&
      companyMemberships[companyIndex].locations[locationIndex] &&
      companyMemberships[companyIndex].locations[locationIndex].address &&
      companyMemberships[companyIndex].locations[locationIndex].address
        .postalCode) ||
    "";
  plantCountry.value =
    (companyMemberships[companyIndex] &&
      companyMemberships[companyIndex].locations &&
      companyMemberships[companyIndex].locations[locationIndex] &&
      companyMemberships[companyIndex].locations[locationIndex].address &&
      companyMemberships[companyIndex].locations[locationIndex].address
        .country) ||
    "";
}

function populateCategoryInfo() {
  var numSelectedOptions = categorySelector.options.length;
  var categoriesToDisplay = Array.from(categorySelector.options).map(function (
    e
  ) {
    return e.value;
  });
  var categories = queryArray(".category-fields");
  categories.forEach(function (category) {
    var categoryWrapper = document.getElementById(category.id);
    if (categoriesToDisplay.includes(category.id)) {
      categoryWrapper.classList.remove("hidden");
    } else {
      categoryWrapper.classList.add("hidden");
      var inputs = queryArray("input, textarea", categoryWrapper);
      inputs.forEach(function (input) {
        if (!input.id.includes("name")) input.value = "";
      });
    }
  });
}

function submitEntry(formFields, formId, formAlert) {
  return formHelpers
    .createFormData(formFields, formId)
    .then(function (formData) {
      return window.fetch("/achievement-award-application/checkout", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify(formData),
      });
    })
    .then(function (response) {
      if (response.ok) {
        return response.json().then(function (data) {
          if (data && data.sessionId) {
            window.stripe.redirectToCheckout({
              sessionId: data.sessionId,
            });
          } else {
            window.location = "/achievement-award-application/complete";
          }
        });
      } else if (response.entered) {
        formAlert.innerHTML =
          "Our records show that we have already received an entry on behalf of that company. We currently allow one submission per year for non-members. If this is incorrect, please contact us for more assistance.";
        nextBtn.innerHTML = "Submit";
        nextBtn.disabled = false;
        document.querySelector("form.form").scrollIntoView();
      } else {
        console.log(response);
        formAlert.innerHTML =
          "There was an issue processing this entry. Please contact us directly for more assistance.";
        nextBtn.innerHTML = "Submit";
        nextBtn.disabled = false;
        document.querySelector("form.form").scrollIntoView();
      }
    });
}

function setListeners() {
  companySelector.addEventListener("change", populateCompanyInfo);
  locationSelector.addEventListener("change", populateLocationInfo);
}

window.achievementAwardHelpers = {
  populateLocationOptions: populateLocationOptions,
  populateLocationInfo: populateLocationInfo,
  populateCompanyInfo: populateCompanyInfo,
  populateCategoryInfo: populateCategoryInfo,
  submitEntry: submitEntry,
};
